export default __webpack_public_path__ + "static/media/edexcelenglish.5ec1cdc1.png";